<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button @click="add()" type="button" variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar Depósito" aria-label="Agregar Depósito">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
      </b-card>

      <b-card>
        <b-row>
          <b-col>
            <b-table class="app-table mb-0 deposit-table-min-height"
                     stacked="md"
                     :hover="true"
                     :small="true"
                     :fixed="false"
                     :items="table.items"
                     :fields="table.fields"
                     :current-page="table.currentPage"
                     :per-page="table.perPage"
                     :busy="table.isBusy"   
                     selectable
                     select-mode="single"                     
                     v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(width)="data">
                  <div v-if="data.item.width">
                    {{data.item.width}} Metros
                  </div>
                </template>

                <template v-slot:cell(height)="data">
                  <div v-if="data.item.height">
                    {{data.item.height}} Metros
                  </div>
                </template>  

                <template v-slot:cell(zone)="data">                  
                  <div v-if="data.item.active" v-html="getZoneObservation(data.item)"></div>
                </template>                                                

                <template v-slot:cell(active)="data">
                  <div v-if="!data.item.active" title="Depósito Inactivo">
                    <AppIcon name="circle-fill" class="text-danger" font-scale="1.2" label="Depósito inactivo" />
                  </div>
                  <div v-else>
                    <AppIcon name="circle-fill" class="text-success" label="Depósito activo" />
                  </div>      
                </template>        

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                    <template #button-content><AppIcon name="more_vert" label="Opciones" /><span class="app-table-action-label">Opciones</span></template>
                    <b-dropdown-item @click="configZone(data.item)" v-if="data.item.active">
                      <AppIcon name="settings" class="mr-1" /> Configuración de Zonas
                    </b-dropdown-item>       

                    <b-dropdown-header>Activo/Inactivo</b-dropdown-header>  
                    <b-dropdown-item @click="active(data.item)" v-if="!data.item.active">
                      <AppIcon name="visibility" class="mr-1" /> Activar
                    </b-dropdown-item>                     
                    <b-dropdown-item @click="active(data.item)" v-if="data.item.active">
                      <AppIcon name="visibility_off" class="mr-1" /> Desactivar
                    </b-dropdown-item>                     
                    
                    <b-dropdown-header>Acciones</b-dropdown-header>  
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" class="mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="warehouse" title="No hay depósitos" description="Agregá un depósito para administrar sus zonas y ubicaciones." />
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="xl"
              body-class="app-modal-form"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="warehouse" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>

        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="6">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Nombre">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Referencia">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.reference"
                                required
                                :readonly="!crud.form.id"
                                placeholder="Referencia">
                  </b-form-input>
                </b-form-group>
              </b-col>    
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="3">
                <b-form-group label="Ancho" description="Ancho en metros">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.height"
                                @change="changeInput">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Largo" description="Largo en metros">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.width"
                                @change="changeInput">
                  </b-form-input>
                </b-form-group>
              </b-col>  
              <b-col md="3">
                <b-form-group label="P.H." description="Pasillos Horizontales">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.rows"
                                @change="changeInput">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="P.V." description="Pasillos Verticales">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.cols"
                                @change="changeInput">
                  </b-form-input>
                </b-form-group>
              </b-col>                
            </b-row>
          </b-col>
        </b-row>      
        <b-row>      
          <b-col id="crud-deposit-area-canva" class="mt-3">
            <canvas id="canvas"></canvas>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" />Cancelar</b-button>
          <b-button variant="primary" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>  

      <!-- CRUD SUBMAIN -->
      <b-modal v-model="modal.formSub.active"
              size="xl"
              body-class="app-modal-form"
              :key="modal.formSub._id"
              :id="modal.formSub._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="grid_view" /></span>
          <h5 class="app-modal-header__title">{{ modal.formSub.title }}</h5>
        </div>

        <b-row>
          <b-col md="4" class="crud-deposit-zone-divide">
            <b-row>
              <b-col md="12" class="mb-2">
                <span class="crud-deposit-zone-legend">Depósito</span>                
              </b-col>

              <b-col md="12" v-if="selectDeposit">
                <b-form-group>
                  <b-form-input type="text"
                                size="sm"
                                v-model="selectDeposit.name"
                                required
                                :readonly="true"
                                placeholder="Depósito">
                  </b-form-input>
                </b-form-group>
              </b-col>  

              <b-col md="12" v-if="selectDeposit">
                <b-form-group>
                  <b-form-input type="text"
                                size="sm"
                                v-model="selectDeposit.reference"
                                required
                                :readonly="true"
                                placeholder="Referencia">
                  </b-form-input>
                </b-form-group>
              </b-col>  

              <b-col md="12" id="crud-deposit-zone-area-canva">               
                <canvas id="canvas-zone"></canvas>            
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="crud-deposit-zone-divide">
            <b-row v-if="crud.formSub.id">
              <b-col md="12" v-if="crud.formSub.deposit" class="mb-2">
                <span class="crud-deposit-zone-legend">Zona</span>
              </b-col>              
              <b-col md="12">
                <b-row>             
                  <b-col md="12">
                    <b-form-group>
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formSub.name"
                                    required
                                    :readonly="true"
                                    placeholder="Nombre">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formSub.reference"
                                    required
                                    :readonly="!crud.formSub.id"
                                    placeholder="Referencia">
                      </b-form-input>
                    </b-form-group>
                  </b-col>    
                  <b-col md="12">
                    <b-form-checkbox v-model="crud.formSub.active" 
                                      switch 
                                      size="sm" 
                                      class="mb-4 pull-left">
                      Activar
                    </b-form-checkbox>            
                  </b-col>                    
                  <b-col md="12" class="">
                    <b-row>
                      <b-col md="12">
                        <b-form-group label="Filas">
                          <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.formSub.rows"
                                        required                                    
                                        placeholder="Filas">
                          </b-form-input>
                        </b-form-group>
                      </b-col>    
                      <b-col md="12">
                        <b-form-group label="Columnas">
                          <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.formSub.cols"
                                        required                                    
                                        placeholder="Columnas">
                          </b-form-input>
                        </b-form-group>                    
                      </b-col>      
                    </b-row>
                  </b-col>                    
                  <b-col md="12">
                    <b-button variant="primary" class="w-100" @click="refreshZone()"><AppIcon name="refresh" class="mr-1" />Actualizar zona</b-button>
                  </b-col>                                       
                </b-row>
              </b-col>
            </b-row>
            <div v-else class="container h-100">
              <div class="row align-items-center h-100">
                <div class="col-12 mx-auto">                  
                  <div class="app-alert app-alert--info">
                    <span class="app-alert__icon"><AppIcon name="info" /></span>
                    <div class="app-alert__content">Seleccioná una zona para acceder a su configuración.</div>
                  </div>
                </div>
              </div>              
            </div>
          </b-col>
          <b-col md="4" v-if="crud.formSub.id">
            <b-row v-if="crud.formSub.rows && crud.formSub.cols">
              <b-col md="12" v-if="crud.formSub.deposit">
                <span class="crud-deposit-zone-legend">Ubicaciones</span>
                <div class="app-alert app-alert--warning mt-2">
                  <span class="app-alert__icon"><AppIcon name="touch_app" /></span>
                  <div class="app-alert__content">Tocá una ubicación para activarla o desactivarla.</div>
                </div>
              </b-col>    
              <b-col md="12" id="crud-deposit-location-area-canva">
                <canvas id="canvas-location"></canvas>            
              </b-col>
            </b-row>
            <div v-else class="container h-100">
              <div class="row align-items-center h-100">
                <div class="col-12 mx-auto">                  
                  <div class="app-alert app-alert--info">
                    <span class="app-alert__icon"><AppIcon name="info" /></span>
                    <div class="app-alert__content">Configurá las filas y columnas de la zona.</div>
                  </div>
                </div>
              </div>              
            </div>            
          </b-col>
        </b-row>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formSub.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>        
      </b-modal>    
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Storage from '@/handler/storageSession'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import Theme from '@/config/theme'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudDeposits',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
            {key: 'name', label: 'Nombre', class: 'align-middle'},            
            {key: 'reference', label: 'Referencia', class: 'align-middle'},          
            {key: 'width', label: 'Largo', class: 'align-middle'},      
            {key: 'height', label: 'Ancho', class: 'align-middle'},      
            {key: 'zone', label: 'Zonas', class: 'align-middle text-center'},      
            {key: 'active', label: 'Activo', class: 'align-middle text-center'},    
            {key: 'f_action', label:'', class: 'align-middle'},
          ],
          isBusy: false,
          currentPage: 1,
          perPage: 50,
        },          
        crud: {
          form: {
            id: 0,
            name: '',  
            reference: '',
            width: 1,       
            height: 1,
            rows: 0,
            cols: 0,
            active: true,
            zones: [],
          },
          formSub: {          
            id: 0,  
            deposit: null,
            deposit_id: 0,    
            name: '',        
            reference: '',
            rows: 0,
            cols: 0,      
            posX: 0,
            posY: 0,
            active: true, 
            locations: [],     
          },     
          formLocation: {
            id: 0,  
            name: '',        
            reference: '',
            active: true,            
          },     
        },
        selectDeposit: null,
        arr: {
          deposits: [],
        },
        modal: {
          form: {
            active: false,
            title: ''
          },   
          formSub: {
            active: false,
            title: ''
          },                     
        },       
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.load()      
    },
    watch: {
      'crud.form.width': function () {      
        this.getDepositCanvas()
      },
      'crud.form.height': function () {              
        this.getDepositCanvas()
      },
      'crud.form.rows': function () {      
        this.getDepositCanvas()
      },
      'crud.form.cols': function () {              
        this.getDepositCanvas()
      },                                 
    },
    methods: { 
      // remder          
      getRowCount (items) {
        return items.length
      },

      // crud deposito
      load() {
        this.table.isBusy = true
        var result = serviceAPI.obtenerDepositos()

        result.then((response) => {
          var data = response.data          
          this.table.items = data
          this.arr.deposits = data
          
          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.reference = ''
        this.crud.form.width = 1
        this.crud.form.height = 1
        this.crud.form.rows = 0
        this.crud.form.cols = 0
        this.crud.form.active = true

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Depósito"
        this.modal.form.active = true

        setTimeout(()=>{
          this.getDepositCanvas()
        },100)
        
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.reference = item.reference
        this.crud.form.width = item.width
        this.crud.form.height = item.height
        this.crud.form.rows = item.rows
        this.crud.form.cols = item.cols
        this.crud.form.active = item.active        

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Depósitos"
        this.modal.form.active = true

        setTimeout(()=>{
          this.getDepositCanvas()
        },100)        
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title,
        ])

        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: 'Sí',
          cancelTitle: 'No',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true,
        })
      },
      remove(item) {
        this.crud.form.id = item.id

        this.confirmDialog('¿Desea borrar el depósito (' + item.id + ') - '+ item.name + '?', {
          title: 'Borrar Depósito',
          icon: 'delete',
          danger: true,
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarDeposito(this.crud.form.id);

            result.then(() => {
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Depósito eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        this.crud.form.zones = JSON.parse(Storage.getValue('deposit_zone_graphic'))

        if (this.crud.form.id) {
          var result = serviceAPI.editarDeposito(this.crud.form);
        } else {
          result = serviceAPI.agregarDeposito(this.crud.form);
        }
        
        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Depósito guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },     
      active(item) {        
        var msj = ''
        var title = ''
        var variant = ''
        var msjResult = ''
        if(item.active) {
          msj = "¿Desea desactivar el depósito?"
          title = "Desactivar Depósito"
          variant = 'danger'
          msjResult = 'Depósito desactivado'
        } else {
          msj = "¿Desea activar el depósito?"
          title = "Activar Depósito"
          variant = "success"
          msjResult = 'Depósito activado'
        }

        this.confirmDialog(msj, {
          title: title,
          icon: item.active ? 'visibility_off' : 'visibility',
          danger: variant === 'danger',
        })
        .then(value => {
          if (value) {

            let loader = this.$loading.show();

            this.crud.form.id = item.id
            this.crud.form.name = item.name
            this.crud.form.reference = item.reference
            this.crud.form.width = item.width
            this.crud.form.height = item.height
            this.crud.form.rows = item.rows
            this.crud.form.cols = item.cols
            this.crud.form.active = !item.active  
            
            var result = serviceAPI.editarDeposito(this.crud.form);

            result.then(() => {
              loader.hide()
              this.load()
              this.$awn.success(msjResult);                    
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })        
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },

      // canvas deposito
      getZoneObservation(item) {

        if(item.zones.length) {
          var count = 0
          item.zones.forEach(element => {
            if(element.active) {
              count = count + 1
            }
          });

          return '<span class="font-weight-bold text-info">' + count + ' Activas</span>';
        } else {
          return '<span class="font-weight-bold text-danger">Sin Zonas</span>';
        }
        
      },      
      changeInput() {
        if(this.crud.form.height<1) {        
          this.crud.form.height = 1
          this.$awn.alert("El valor no puede ser igual o menor a cero")          
        }
        if(this.crud.form.width<1) {        
          this.crud.form.width = 1
          this.$awn.alert("El valor no puede ser igual o menor a cero")          
        }              
        if(this.crud.form.rows<0) {        
          this.crud.form.rows = 0
          this.$awn.alert("El valor no puede ser negativo")          
        }            
        if(this.crud.form.cols<0) {        
          this.crud.form.cols = 0
          this.$awn.alert("El valor no puede ser negativo")          
        }              
      },      
      getCanvasColors() {
        return {
          text: Theme.getColor(Theme.TOKENS.text),
          border: Theme.getColor(Theme.TOKENS.border),
          surfaceStrong: Theme.getColor('--app-color-surface-strong'),
          success: Theme.getColor(Theme.TOKENS.success),
          danger: Theme.getColor(Theme.TOKENS.danger),
        }
      },
      getDepositCanvas() {          
        var width = parseFloat(this.crud.form.width)
        var height = parseFloat(this.crud.form.height)
        var rows = parseFloat(this.crud.form.rows)
        var cols = parseFloat(this.crud.form.cols)

        if(width>0 && height>0) {
          if(width > height) {
            this.drawDeposit('crud-deposit-area-canva', 'canvas', 350, 200, width + ' metros', height + ' metros', rows, cols, true, false, null)
          } 
          if(width < height) {
            this.drawDeposit('crud-deposit-area-canva', 'canvas', 200, 350, width + ' metros', height + ' metros', rows, cols, true, false, null)
          }            
          if(width == height) {
            this.drawDeposit('crud-deposit-area-canva', 'canvas', 350, 350, width + ' metros', height + ' metros', rows, cols, true, false, null)
          }            
        }         
      },
      drawDeposit(area, element, width, height, textWidth, textHeight, rows, cols, showText, clickZone, arrZoneConfig) {        
        var arrZones = []
        var colors = this.getCanvasColors()
        const areaCanvas = document.getElementById(area);    
        const canvas = document.getElementById(element);  
                  
        if(areaCanvas && canvas) {
          canvas.width = areaCanvas.clientWidth - 30;
          canvas.height = areaCanvas.clientHeight;      
          
          if(clickZone) {
            this.clickDespositZone(element)
          }

          const ctx = canvas.getContext("2d");

          let x = (canvas.width-parseFloat(width))/2
          let y = (canvas.height-parseFloat(height))/2      
          
          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.strokeStyle = colors.border;
          ctx.fillStyle = colors.surfaceStrong;
          ctx.rect(x, y, width, height);
          ctx.stroke();
          ctx.fill();    

          if(showText) {
            ctx.beginPath();
            ctx.textAlign='center';
            ctx.font='20px Arial';
            ctx.fillStyle=colors.text;
            ctx.fillText(textWidth,(x + (parseFloat(width)/2)), (y - 5));
            
            ctx.beginPath();
            ctx.textAlign='end';
            ctx.font='20px Arial';
            ctx.fillStyle=colors.text;
            ctx.fillText(textHeight,(x - 5), (y + (parseFloat(height)/2)));            
          }
          
          rows = parseFloat(rows) + 1
          cols = parseFloat(cols) + 1

          let widthZone = parseFloat(width)
          let heightZone = parseFloat(height)      
          if(cols) {widthZone = parseFloat(width) / parseFloat(cols)}
          if(rows) {heightZone = parseFloat(height) / parseFloat(rows)}

          let count = 1
          for (let index = 0; index < rows; index++) {                      
              x = (canvas.width-parseFloat(width))/2
              for (let index1 = 0; index1 < cols; index1++) {                                  
                  var active = true                  
                  if(arrZoneConfig) {                    
                    active = arrZoneConfig[index][index1].active
                  } 

                  arrZones.push({
                    rows: index,
                    cols: index1,
                    ejeX: x,
                    ejeY: y,
                    width: widthZone,                
                    height: heightZone,
                  })

                  ctx.beginPath();
                  ctx.lineWidth = 1;                  
                  ctx.strokeStyle = colors.border;

                  if(active) {
                    ctx.fillStyle = colors.success;
                  } else {
                    ctx.fillStyle = colors.danger;
                  }

                  ctx.rect(x, y, widthZone, heightZone);
                  ctx.stroke();
                  ctx.fill();  
                  
                  ctx.beginPath();
                  let textWidth = "Z: " + count
                  ctx.textAlign='center';
                  ctx.font='12px Arial';
                  ctx.fillStyle=colors.text;
                  ctx.fillText(textWidth,x + (widthZone/2), y + (heightZone/2));

                  count = count + 1
                  x += widthZone;
              }
              y += heightZone;
          }      
        }

        Storage.removeValue('deposit_zone_graphic')
        Storage.setValue('deposit_zone_graphic', JSON.stringify(arrZones))    
      },
      clickDespositZone(element) {    
        const canvas = document.getElementById(element);     
        canvas.removeEventListener("click", this.eventClickDespositZone);     
        canvas.addEventListener('click', this.eventClickDespositZone, false);  
      },   
      eventClickDespositZone(event) {  
        var x = event.layerX;
        var y = event.layerY;
        
        var arrZones = JSON.parse(Storage.getValue('deposit_zone_graphic'))
        
        if(arrZones) {
          arrZones.forEach(element => {                        
            if( element.ejeX < x && (element.ejeX + element.width) > x &&
                element.ejeY < y && (element.ejeY + element.height) > y ) {
              this.getZoneByPosition(element)
            }
          });    
        }
      },      
            
      // canvas deposito zona
      configZone(item) {                
        this.crud.formSub.deposit = item
        this.crud.formSub.deposit_id = item.id

        this.crud.formSub.id = 0
        this.crud.formSub.name = ''
        this.crud.formSub.reference = ''
        this.crud.formSub.active = true

        this.modal.formSub._id = Math.random().toString(36).slice(2, 8)
        this.modal.formSub.title = "Configuración de Zonas"
        this.modal.formSub.active = true

        setTimeout(()=>{
          this.getZonasCanvas(item)
        },100)        
      },
      getZonasCanvas(item) {
        this.selectDeposit = item

        var width = parseFloat(item.width)
        var height = parseFloat(item.height)
        var rows = parseFloat(item.rows)
        var cols = parseFloat(item.cols)

        var arrZone = []
        if(item.zones) {
          item.zones.forEach(element => {
            
            if(arrZone[element.posX] == undefined)
              arrZone[element.posX] = []
            
            if(arrZone[element.posX][element.posY] == undefined)
              arrZone[element.posX][element.posY] = []
            
            arrZone[element.posX][element.posY] = {
              id: element.id,              
              active: element.active
            }

          });
        }        

        if(width>0 && height>0) {
          if(width > height) {
            this.drawDeposit('crud-deposit-zone-area-canva', 'canvas-zone', 300, 150, width + ' metros', height + ' metros', rows, cols, false, true, arrZone)
          } 
          if(width < height) {
            this.drawDeposit('crud-deposit-zone-area-canva', 'canvas-zone', 150, 300, width + ' metros', height + ' metros', rows, cols, false, true, arrZone)
          }            
          if(width == height) {
            this.drawDeposit('crud-deposit-zone-area-canva', 'canvas-zone', 250, 250, width + ' metros', height + ' metros', rows, cols, false, true, arrZone)
          }            
        }             
      },
      getZoneByPosition(element) {                
        let loader = this.$loading.show();

        var result = serviceAPI.obtenerZonaByPosition({
          deposit_id: this.crud.formSub.deposit_id,
          posX: element.rows,
          posY: element.cols,
        })

        result.then((response) => {
          loader.hide()         

          var data = response.data    

          this.crud.formSub.id = data.id
          this.crud.formSub.name = data.name
          this.crud.formSub.reference = data.reference
          this.crud.formSub.rows = data.rows
          this.crud.formSub.cols = data.cols
          this.crud.formSub.posX = data.posX
          this.crud.formSub.posY = data.posY
          this.crud.formSub.active = data.active      
          
          setTimeout(()=>{
            this.generateLocations(data, 'draw-from-data')
          },100)          
        })
        .catch(() => {
          loader.hide()          
        })        
      },
      refreshZone() {
        let loader = this.$loading.show();
        
        this.generateLocations(this.crud.formSub, 'draw')        
        this.crud.formSub.locations = JSON.parse(Storage.getValue('deposit_zone_location_graphic'))        

        var result = serviceAPI.editarZona(this.crud.formSub);
        
        result.then((response) => {                    
          loader.hide()                 
          var data = response.data          
          this.$awn.success("Zona actualizada con éxito");

          if(this.selectDeposit) {            
            if(this.selectDeposit.zones) {
              this.selectDeposit.zones.forEach(element => {
                if(element.id == data.id) {
                  element.name = data.name
                  element.reference = data.reference
                  element.rows = data.rows
                  element.cols = data.cols                  
                  element.active = data.active
                }
              });
            }            
            this.getZonasCanvas(this.selectDeposit)

            setTimeout(()=>{
              this.generateLocations(data, 'draw-from-data')
            },100)              
          }
        })
        .catch(error => {          
          this.getZoneByPosition({
            rows: this.crud.formSub.posX,
            cols: this.crud.formSub.posY,
          })

          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },

      // canvas deposito ubicaciones
      generateLocations(item, type) {        
        var width = 250
        var height = 250
        var rows = parseFloat(item.rows)
        var cols = parseFloat(item.cols)

        var arrLocations = []
        if(item.locations) {
          item.locations.forEach(element => {
            
            if(arrLocations[element.posX] == undefined)
              arrLocations[element.posX] = []
            
            if(arrLocations[element.posX][element.posY] == undefined)
              arrLocations[element.posX][element.posY] = []
            
            arrLocations[element.posX][element.posY] = {
              id: element.id,              
              active: element.active
            }

          });
        }    

        if(type=='draw') {
          this.drawLocations('crud-deposit-location-area-canva', 'canvas-location', width, height, rows, cols, true, null)
        }
        if(type=='draw-from-data') {
          this.drawLocations('crud-deposit-location-area-canva', 'canvas-location', width, height, rows, cols, true, arrLocations)
        }
        
      },
      drawLocations(area, element, width, height, rows, cols, clickLocation, arrLocationConfig) {        
        var arrLocations = []
        var colors = this.getCanvasColors()
        const areaCanvas = document.getElementById(area);    
        const canvas = document.getElementById(element);  
                  
        if(areaCanvas && canvas) {
          canvas.width = areaCanvas.clientWidth - 30;
          canvas.height = areaCanvas.clientHeight;      
          
          if(clickLocation) {
            this.clickDespositLocation(element)
          }

          const ctx = canvas.getContext("2d");

          let x = (canvas.width-parseFloat(width))/2
          let y = (canvas.height-parseFloat(height))/2      
                              
          rows = parseFloat(rows)
          cols = parseFloat(cols)

          let widthZone = parseFloat(width)
          let heightZone = parseFloat(height)      
          if(cols) {widthZone = parseFloat(width) / parseFloat(cols)}
          if(rows) {heightZone = parseFloat(height) / parseFloat(rows)}

          let count = 1
          for (let index = 0; index < rows; index++) {                      
              x = (canvas.width-parseFloat(width))/2
              for (let index1 = 0; index1 < cols; index1++) {                                  
                  var active = true                                    
                  if(arrLocationConfig) {                    
                    active = arrLocationConfig[index][index1].active
                  } 

                  arrLocations.push({
                    rows: index,
                    cols: index1,
                    ejeX: x,
                    ejeY: y,
                    width: widthZone,                
                    height: heightZone,
                  })

                  ctx.beginPath();
                  ctx.lineWidth = 1;                  
                  ctx.strokeStyle = colors.border;

                  if(active) {
                    ctx.fillStyle = colors.success;
                  } else {
                    ctx.fillStyle = colors.danger;
                  }

                  ctx.rect(x, y, widthZone, heightZone);
                  ctx.stroke();
                  ctx.fill();  
                  
                  ctx.beginPath();
                  let textWidth = "U: " + count
                  ctx.textAlign='center';
                  ctx.font='12px Arial';
                  ctx.fillStyle=colors.text;
                  ctx.fillText(textWidth,x + (widthZone/2), y + (heightZone/2));

                  count = count + 1
                  x += widthZone;
              }
              y += heightZone;
          }      
        }

        Storage.removeValue('deposit_zone_location_graphic')
        Storage.setValue('deposit_zone_location_graphic', JSON.stringify(arrLocations))    
      },     
      clickDespositLocation(element) {    
        const canvas = document.getElementById(element);     
        canvas.removeEventListener("click", this.eventClickDespositLocation);     
        canvas.addEventListener('click', this.eventClickDespositLocation, false);  
      },   
      eventClickDespositLocation(event) {  
        var x = event.layerX;
        var y = event.layerY;
        
        var arrLocations = JSON.parse(Storage.getValue('deposit_zone_location_graphic'))
        
        if(arrLocations) {
          arrLocations.forEach(element => {                        
            if( element.ejeX < x && (element.ejeX + element.width) > x &&
                element.ejeY < y && (element.ejeY + element.height) > y ) {
              this.getLocationByPosition(element)
            }
          });    
        }
      },  
      getLocationByPosition(element) {              
        let loader = this.$loading.show();

        var result = serviceAPI.obtenerUbicacionByPosition({
          zone_id: this.crud.formSub.id,
          posX: element.rows,
          posY: element.cols,
        })

        result.then((response) => {
          loader.hide()         

          var data = response.data    

          this.crud.formLocation.id = data.id
          this.crud.formLocation.name = data.name
          this.crud.formLocation.reference = data.reference
          this.crud.formLocation.active = data.active     
          
          this.setStatusLocations(this.crud.formLocation)
        })
        .catch(() => {
          loader.hide()          
        })       
      },

      setStatusLocations(item) {
        var msj = ''
        var title = ''
        var variant = ''        

        if(item.active) {
          msj = '¿Desea desactivar ubicación "' + item.reference + '"?'
          title = 'Desactivar Ubicación'
          variant = 'danger'                  
          this.crud.formLocation.active = false
        } else {
          msj = '¿Desea activar ubicación "' + item.reference + '"?'
          title = 'Activar Ubicación'
          variant = 'success'          
          this.crud.formLocation.active = true
        }

        this.confirmDialog(msj, {
          title: title,
          icon: item.active ? 'visibility_off' : 'visibility',
          danger: variant === 'danger',
        })
        .then(value => {
          if (value) {            
            let loader = this.$loading.show();
            var result = serviceAPI.editarUbicacion(item);

            result.then((response) => {      
              loader.hide() 
              var data = response.data

              this.getZoneByPosition({
                rows: data.zone.posX,
                cols: data.zone.posY,
              })

              this.$awn.success("Estado de la ubicación actualizada");
            })
            .catch(error => {
              loader.hide() 
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })        
      },      
    }    
  }
</script>

<style>
  .deposit-table-min-height {
    min-height: 75px;
  }
  #crud-deposit-area-canva,
  #crud-deposit-zone-area-canva,
  #crud-deposit-location-area-canva {
    overflow: hidden;
    border: 1px solid var(--app-color-border);
    border-radius: 10px;
    background: var(--app-color-surface-subtle);
  }
  #crud-deposit-area-canva {
    height: 400px;
  }
  #crud-deposit-zone-area-canva {
    height: 350px;
  }  
  #crud-deposit-location-area-canva {
    height: 400px;
  }  
  .crud-deposit-zone-divide {
    border-right: 1px solid var(--app-color-border);
  }
  .crud-deposit-zone-legend {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
  .crud-deposit-zone-title {
    text-transform: uppercase;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
  }
  @media (max-width: 767.98px) {
    #crud-deposit-area-canva,
    #crud-deposit-location-area-canva {
      height: 300px;
    }
    #crud-deposit-zone-area-canva {
      height: 280px;
    }
    .crud-deposit-zone-divide {
      margin-bottom: 18px;
      padding-bottom: 18px;
      border-right: 0;
      border-bottom: 1px solid var(--app-color-border);
    }
  }
</style>
